import React, { useState, useEffect } from 'react';
import { Card, Button, message, Spin, Space, Alert } from 'antd';
import {
  getEnterpriseMarketingConfig,
  enableMarketingConfig,
} from '@/services/promotion';
import PreviewArea from './PreviewArea';
import ConfigArea from './ConfigArea';
import styles from './index.less';

// eslint-disable-next-line react/prop-types
const PromotionModuleManage = ({ enterpriseId }) => {
  const [loading, setLoading] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [pageData, setPageData] = useState({
    title: '',
    subTitle: '',
    promotionModuleList: [],
    appModuleTabList: [],
  });
  const [systemConfig, setSystemConfig] = useState(null);

  useEffect(() => {
    fetchData();
  }, [enterpriseId]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { code, data, msg } = await getEnterpriseMarketingConfig({
        requestData: {
          enterpriseId: enterpriseId,
        },
      });
      if (code === '00000') {
        setPageData({
          title: data?.marketingConfig?.title || '',
          subTitle: data?.marketingConfig?.subTitle || '',
          promotionModuleList: data?.marketingConfig?.marketingModuleList || [],
          appModuleTabList: data?.appModuleTabList || [],
        });
        setSystemConfig(data?.systemMarketingConfig || null);
        setHasUnsavedChanges(false);
      } else {
        message.error(msg || '获取配置失败');
      }
    } catch (error) {
      message.error(error?.message || '获取配置失败');
    } finally {
      setLoading(false);
    }
  };

  const handleRestoreDefault = () => {
    if (systemConfig) {
      setPageData({
        ...pageData,
        title: systemConfig.title || '',
        subTitle: systemConfig.subTitle || '',
        promotionModuleList: systemConfig.marketingModuleList || [],
      });
      setHasUnsavedChanges(true);
      message.success('已恢复系统默认数据，请点击保存配置生效');
    } else {
      message.error('未获取到系统默认配置');
    }
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const { code, msg } = await enableMarketingConfig({
        requestData: {
          enterpriseId: enterpriseId || 691,
          marketingConfig: {
            title: pageData.title,
            subTitle: pageData.subTitle,
            marketingModuleList: pageData.promotionModuleList,
          },
        },
      });
      if (code === '00000') {
        message.success('保存成功');
        setHasUnsavedChanges(false);
      } else {
        message.error(msg || '保存失败');
      }
    } catch (error) {
      message.error(error?.message || '保存失败');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (newPromotionModuleList) => {
    setPageData({
      ...pageData,
      promotionModuleList: newPromotionModuleList,
    });
    setHasUnsavedChanges(true);
  };

  const handleTitleChange = (e) => {
    setPageData({ ...pageData, title: e.target.value });
    setHasUnsavedChanges(true);
  };

  const handleSubTitleChange = (e) => {
    setPageData({ ...pageData, subTitle: e.target.value });
    setHasUnsavedChanges(true);
  };

  return (
    <Card
      title="推广模块配置"
      extra={
        <Space>
          <Button onClick={handleRestoreDefault} loading={loading}>
            恢复系统默认
          </Button>
          <Button type="primary" onClick={handleSave} loading={loading}>
            保存配置
          </Button>
        </Space>
      }
      className={styles.container}
    >
      <Spin spinning={loading}>
        {hasUnsavedChanges && (
          <Alert
            message="当前有未保存的变更，请点击右上角「保存配置」"
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
        <div className={styles.layout}>
          <div className={styles.previewSider}>
            <PreviewArea data={pageData} />
          </div>
          <div className={styles.configContent}>
            <ConfigArea
              moduleList={pageData.promotionModuleList}
              onChange={handleChange}
              title={pageData.title}
              subTitle={pageData.subTitle}
              onTitleChange={handleTitleChange}
              onSubTitleChange={handleSubTitleChange}
              appModuleTabList={pageData.appModuleTabList}
            />
          </div>
        </div>
      </Spin>
    </Card>
  );
};

export default PromotionModuleManage;
